import { useCallback, useMemo } from "react";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { useDeleteRequest } from "../ApiWrappers/useDeleteRequest";

export const useDeleteTrialDemo = () => {
    const { deleteRequest, requestResponse, requestError, requestLoading } = useDeleteRequest();
    const baseUrl = useMemo(() => Config.GetConfigData().serviceUrl, []);
    console.log(baseUrl);
    const removeClinicLicense = useCallback((entitlementId: string, distributorId: string) => {
        const requestUrl = `${baseUrl}api/v1/aura-support/distributor/${distributorId}/license/${entitlementId}`;
        deleteRequest(requestUrl);
    }, [baseUrl, deleteRequest]);

    return { requestResponse, requestError, requestLoading, removeClinicLicense };
}
